import React, { useEffect, useRef, useState } from "react";
import { PrepBanner } from "../components/PrepBanner";
import { Hero } from "../components/Hero";
import { StickyOfferBar } from "../components/StickyOfferBar";
import { StatsStrip } from "../components/StatsStrip";
import { SituationFinder } from "../components/SituationFinder";
import { SampleCarousel } from "../components/SampleCarousel";
import { SolutionSection } from "../components/SolutionSection";
import { WorkshopsSection } from "../components/WorkshopsSection";
import { BonusesSection } from "../components/BonusesSection";
import { OfferSection } from "../components/OfferSection";
import { FaqSection } from "../components/FaqSection";
import { ClosingSection } from "../components/ClosingSection";
import { SiteFooter } from "../components/SiteFooter";
export function Landing() {
  const heroRef = useRef<HTMLDivElement>(null);
  const offerRef = useRef<HTMLDivElement>(null);
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const heroObserver = new IntersectionObserver(([entry]) => setPastHero(!entry.isIntersecting));
    const offerObserver = new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
      threshold: 0.15
    });
    if (heroRef.current) heroObserver.observe(heroRef.current);
    if (offerRef.current) offerObserver.observe(offerRef.current);
    return () => {
      heroObserver.disconnect();
      offerObserver.disconnect();
    };
  }, []);
  return <div className="page min-h-screen w-full" data-id="element-305" data-mp="h115bcdf4akt">
      <a className="skip-link" href="#main-content" data-id="element-306" data-mp="c7epjbbyjqks">
        Skip to content
      </a>
      <StickyOfferBar visible={pastHero && !offerVisible} data-id="element-307" data-mp="79dad1hnkbel" />
      <PrepBanner data-id="element-308" data-mp="78v4re93oku0" />
      <main id="main-content" data-id="element-309" data-mp="14oiowkmj42cp">
        <div ref={heroRef} data-id="element-310" data-mp="14or26dmkd9of">
          <Hero data-id="element-311" data-mp="14q26cejx8jg2" />
        </div>
        <StatsStrip data-id="element-312" data-mp="14qbzgb09j6pz" />
        <SituationFinder data-id="element-313" data-mp="zy28qsrbq2mn" />
        <SampleCarousel data-id="element-314" data-mp="zwr64w9m70x4" />
        <SolutionSection data-id="element-315" data-mp="zwhfr7knqrqw" />
        <WorkshopsSection data-id="element-316" data-mp="1iu15jz9kq3kl" />
        <BonusesSection data-id="element-317" data-mp="1itrdm64yxmc9" />
        <div ref={offerRef} data-id="element-318" data-mp="1ivc7dtjgl192">
          <OfferSection data-id="element-319" data-mp="1iw427258euya" />
        </div>
        <FaqSection data-id="element-320" data-mp="1ntnliggsdxx3" />
        <ClosingSection data-id="element-321" data-mp="1nrswapyhfjn7" />
      </main>
      <SiteFooter data-id="element-322" data-mp="1nuyls6b0wnjg" />
    </div>;
}